import type { ModelRegistry } from 'ember-data/types/registries/model';
import type { TeammateShapeKey } from 'uplisting-frontend/utils/teammate-shapes';
interface PendingChange {
  permission: string;
  target: TeammateShapeKey;
  permitted: boolean;
}

export interface CategoryGroup<T> {
  category: string;
  rows: T[];
}

type PermissionSettingsGroup = CategoryGroup<
  ModelRegistry['permission-setting']
>;

export interface PermissionSettingsMatrixGroup extends PermissionSettingsGroup {
  isOpen: boolean;
}

export function pendingKey(
  permission: string,
  target: TeammateShapeKey,
): string {
  return `${permission}|${target}`;
}

export function parsePendingKey(key: string): {
  permission: string;
  target: TeammateShapeKey;
} {
  const separator = key.lastIndexOf('|');

  return {
    permission: key.slice(0, separator),
    target: key.slice(separator + 1) as TeammateShapeKey,
  };
}

export function groupByCategory<T extends { category: string }>(
  rows: T[],
): CategoryGroup<T>[] {
  const groups: CategoryGroup<T>[] = [];

  for (const row of rows) {
    const group = groups.find((item) => item.category === row.category);

    if (group) {
      group.rows.push(row);
    } else {
      groups.push({ category: row.category, rows: [row] });
    }
  }

  return groups;
}

export function pendingChanges(
  pending: ReadonlyMap<string, boolean>,
): PendingChange[] {
  return [...pending.entries()].map(([key, permitted]) => ({
    ...parsePendingKey(key),
    permitted,
  }));
}

export function changedTargets(
  pending: ReadonlyMap<string, boolean>,
): TeammateShapeKey[] {
  const targets = new Set<TeammateShapeKey>();

  for (const change of pendingChanges(pending)) {
    targets.add(change.target);
  }

  return [...targets];
}
